<template>
  <div>
    <!-- 룸 {{ selectedItem }} -->
    <!-- <div style="width:500px; ">
    {{ roomData }}
    </div>  -->
    <div class="cd-info" v-show="roomData.room_code">{{ roomData.room_code }}</div>

    <div class="flex">
      <v-select dense outlined 
        class="selectmid"
        id="company" 
        ref="companySelect" 
        label="경영체✽" 
        v-model="roomData.company"
        :items="companyItems"
        :menu-props="{ top: false, offsetY: true }"
        item-text="name"
        return-object
        @change="updateSelectedCompany"
      />

      <v-select dense outlined
        class="selectmid"
        id="farm" 
        ref="farm" 
        :label="['CF02', 'CF01', 'CF06', 'CF05'].includes(selectedItem.farm.farm_biz) ? '농장명✽' : '사업장명✽'"
        v-model="roomData.farm"
        :items="farmItems"
        :menu-props="{ top: false, offsetY: true }"
        item-text="name"
        return-object
        @focus="comboFarms()"
      />

      <v-select dense outlined 
        class="selectmid"
        id="building" 
        ref="building" 
        :label="['CF02', 'CF01', 'CF06', 'CF05'].includes(selectedItem.farm.farm_biz) ? '축사명✽' : '건물명✽'"
        v-model="roomData.building"
        :items="buildingItems"
        :menu-props="{ top: false, offsetY: true }"
        no-data-text="등록된 자료가 없거나 접근 권한이 없습니다."
        item-text="name"
        return-object
        @change="changeBuilding()"
        @focus="comboBuildings()"
        clearable
      />
    </div>

    <div class="mt-2 flex">
      <v-text-field dense outlined
        class="textfield"
        id="room_name" 
        ref="room_name" 
        :label="{
          CF02: '돈방명✽',
          CF04: '계사명✽',
          CF05: '우사명✽',
          CF06: '우사명✽'  
        }[selectedItem.farm.farm_biz] || '위치명✽'"
        v-model="roomData.room_name" 
      />
      <v-text-field dense outlined
        class="textfield"
        style="max-width:130px;"
        id="area" 
        ref="area" 
        label="면적"
        placeholder="시작 및 천장위치를 모르실 경우 입력해주세요." 
        suffix="m²"
        onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
        maxlength="7"
        v-model="roomData.area" 
      />
    </div>

    <div class="mt-3 pig-content" v-show="roomData.building_group === 'BF01'">
      <div class="flex">
        <v-select dense outlined
          class="selectmin"
          id="room_type" 
          ref="room_type" 
          :items="room_typeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          label="돈사구분✽" 
          v-model="roomData.room_type" 
          return-object
        />
        <v-text-field dense outlined 
          class="textfield"
          style="max-width:130px;"
          id="max_pigcnt" 
          ref="max_pigcnt" 
          label="최대사육두수"
          suffix="두" 
          v-model="roomData.max_pigcnt" 
          onKeyup="this.value=this.value.replace(/[^0-9]/g,'');"
          maxlength="3"
        />
      </div>
      <div class="flex mt-2">
        <v-select dense outlined
          id="feedertype" 
          ref="feedertype" 
          :items="feedertypeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          label="급이기유형" 
          v-model="roomData.feedertype" 
          return-object
          clearable
        />
        <v-select dense outlined
          id="bottom" 
          ref="bottom" 
          :items="bottomItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          label="바닥유형" 
          v-model="roomData.bottom" 
          return-object
          clearable
        />
      </div>
      <div class="flex mt-2">
        <v-select dense outlined 
          id="cooltype" 
          ref="cooltype" 
          :items="cooltypeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          label="냉각방법" 
          v-model="roomData.cooltype" 
          return-object
          clearable
        />
        <v-select dense outlined
          id="heattype" 
          ref="heattype" 
          :items="heattypeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          label="보온방법" 
          v-model="roomData.heattype" 
          clearable
          return-object
        />
      </div>
      
      <div class="pig-content space-info mt-2">
        <div class="ml-2 mt-3">
          <span class="txt-info">공간 정보 </span>
          <!-- <span class="sub-info">ⓘ 등록하시는 돈방에 대한 면적 정보를 입력하는 곳입니다.</span> -->
        </div>

        <div class="flex" style="align-items: center;">  
          <div class="space-title"> 시작 위치 </div>
          <v-text-field dense outlined
            class="textfield" 
            style="max-width:190px;"
            id="xposition" 
            ref="xposition" 
            label="가로" 
            suffix="m" 
            v-model="roomData.xposition" 
            onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
            maxlength="4"
          />
          <v-text-field dense outlined
            class="textfield" 
            style="max-width:190px;"
            id="yposition" 
            ref="yposition" 
            label="세로" 
            suffix="m" 
            v-model="roomData.yposition" 
            onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
            maxlength="4"
          />
        </div>

        <div class="flex vertical-center mt-3 mb-2">  
          <div class="space-title"> 천장 위치 </div>
          <v-text-field dense outlined
              class="textfield" 
              style="max-width:190px;"
              id="roofheight_h" 
              ref="roofheight_h" 
              label="천장 최고높이" 
              suffix="m" 
              v-model="roomData.roofheight_h" 
              onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
              maxlength="4"
            />
            <v-text-field dense outlined
              class="textfield" 
              id="roofheight_l" 
              ref="roofheight_l" 
              label="천장 최저높이" 
              suffix="m" 
              v-model="roomData.roofheight_l" 
              onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
              maxlength="4"
            />
        </div>
        
        <!-- <div class="space-container mb-7">
          <v-text-field dense outlined
            class="sp-textfield" 
            style="max-width:100px; position:absolute; left:-50px; top:50%; transform:translateY(40%);" 
            id="yposition" 
            ref="yposition" 
            label="세로" 
            suffix="m" 
            v-model="roomData.yposition" 
            onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
            maxlength="4"
          />

          <div class="ceiling">
            <v-text-field dense outlined
              class="sp-textfield" 
              style="max-width:110px; position:absolute; right:10px; top:5px;" 
              id="roofheight_h" 
              ref="roofheight_h" 
              label="천장 최고높이" 
              suffix="m" 
              v-model="roomData.roofheight_h" 
              onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
              maxlength="4"
            />
            <v-text-field dense outlined
              class="sp-textfield" 
              style="max-width:110px; position:absolute; left:10px; bottom:20px;" 
              id="roofheight_l" 
              ref="roofheight_l" 
              label="천장 최저높이" 
              suffix="m" 
              v-model="roomData.roofheight_l" 
              onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
              maxlength="4"
            />
          </div>

          <v-text-field dense outlined
            class="sp-textfield" 
            style="max-width:100px; position:absolute; top:100%; left:50%; transform:translate(-50%, -50%);" 
            id="xposition" 
            ref="xposition" 
            label="가로" 
            suffix="m" 
            v-model="roomData.xposition" 
            onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
            maxlength="4"
          />
        </div> -->
      </div>
    </div>

    <div class="hint-text">
      {{ roomData.hintRoom }}
    </div>

   <!-- <div class="mt-3">
      <v-menu
        v-model="menuRoomDeldate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field dense outlined clearable
          class="textfield"  
          id="deldate" 
            ref="deldate" 
            v-model="roomData.deldate"
            label="사용중지일"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          no-title locale="ko-KR"
          v-model="roomData.deldate"
          @input="menuRoomDeldate = false"
        ></v-date-picker>
      </v-menu>
    </div>

    <div class="mt-2">
      <v-textarea outlined dense rows="2"
        style="height:50px;"
        class="textarea-field"
        label="비고"
        id="history" 
        ref="history" 
        v-model="roomData.history"
        value=""
        persistent-hint
        :hint="roomData.hintRoom"
      ></v-textarea>
    </div> -->

    <div class="mt-5 flex vertical-center">
      <v-btn
          class="normal-btn mr-3"
          text
          id="save" 
          ref="save" 
          type="submit" 
          @click.prevent="save()"
        >
          저장
        </v-btn>
        <v-btn 
          class="new-btn"
          text
          id="newRegister" 
          ref="newRegister" 
          @click="resetRoomData()">
          새로등록
        </v-btn>
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis'
import Common from "@/utils/custom/common.js";
import dateUtil from "@/utils/custom/dateProperty.js";

export default{
  name: 'Room',

  props: {
    selectedItem: {
      type: Object,
      default: null,
    },
    selectedCompany: {
      type: [String, Object], // 데이터 유형에 따라 수정
      default: null,
    },
  },
  watch: {
    selectedItem: {
      immediate: true,
      handler(newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.roomData = { ...this.roomData, ...newValue }; 
        } else {
          this.resetRoomData(); 
        }
      },
    },
    selectedCompany: {
      immediate: true,
      handler(newValue, oldValue) {
        this.resetRoomData();
        if (newValue) {
          const company = this.companyItems.find(
            (item) => item.code === newValue
          );
          this.roomData.company = company || null;
          this.roomData.farm = {}; 
          this.roomData.building = {}; 
        }
      },
    },
  },
  data:() => ({
    roomData:{
      company : {},
      farm : {},
      building : {},

      room_code : "",
      room_name : "",
      room_type : "",
      max_pigcnt : "",
      bottom : "",
      cooltype : "",
      heattype : "",
      roofheight_h : "",
      roofheight_l : "",

      area : 0,
      building_group : "",

      xposition : "",
      yposition : "",
      feedertype : "",

      // deldate: "",
      // history: "",
    },

    companyItems: [],
    farmItems:[],
    buildingItems : [],

    room_typeItems : Common.comboBaseCode("RT"),
    bottomItems : Common.comboBaseCode("BO"),
    cooltypeItems : Common.comboBaseCode("CT"),
    heattypeItems : Common.comboBaseCode("HT"),
    feedertypeItems : Common.comboBaseCode("FE"),

    menuRoomDeldate:false,
  }),
  created(){
    this.comboCompanies();
    this.comboFarms();
    this.comboBuildings();
  },
  methods:{
    save(){
      this.$store.commit("resMessage","");
      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        // alert(msgCheckdata);
        return;
      }

      if (this.roomData.room_code) {
        // console.log('update')
        Apis.updateRoom({
          room_cd: this.roomData.room_code,
          company_cd: this.roomData.company.code,
          farm_cd: this.roomData.farm.code,
          building_cd: this.roomData.building.code,
          room_name: this.roomData.room_name.trim(),
          // 면적 넣기
          area: Number(this.roomData.area) || 0,
          room_type: this.roomData.room_type && this.roomData.room_type.code || "",
          max_pigcnt: Number(this.roomData.max_pigcnt) || 0,
          bottom: this.roomData.bottom && this.roomData.bottom.code || "",
          cooltype: this.roomData.cooltype && this.roomData.cooltype.code || "",
          heattype: this.roomData.heattype && this.roomData.heattype.code || "",
          roofheight_h: Number(this.roomData.roofheight_h) || 0.0,
          roofheight_l: Number(this.roomData.roofheight_l) || 0.0,
          xposition: Number(this.roomData.xposition) || 0.0,
          yposition: Number(this.roomData.yposition) || 0.0,
          feedertype: this.roomData.feedertype && this.roomData.feedertype.code || "",
          // deldate: '',
          // history: '',
          },(res) => {  
            if (res.result) {
              this.$store.commit("resMessage",res.message);
              this.msgFlag = false;

              this.resetRoomData();
              this.$emit("refreshTreeData");
            } else {
              this.loadingSave = false;
              alert(res.message);
            }
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("updateRoom API 호출 오류",err)
              alert(err);
          }
        )
      }else{
        // console.log('인서트')
        Apis.insertRoom({
          company_cd: this.roomData.company.code,
          farm_cd: this.roomData.farm.code,
          building_cd: this.roomData.building.code,
          room_name: this.roomData.room_name.trim(),
          room_type: this.roomData.room_type && this.roomData.room_type.code || "",
          area: Number(this.roomData.area) || 0,
          max_pigcnt: Number(this.roomData.max_pigcnt) || 0,
          bottom: this.roomData.bottom && this.roomData.bottom.code || "",
          cooltype: this.roomData.cooltype && this.roomData.cooltype.code || "",
          heattype: this.roomData.heattype && this.roomData.heattype.code || "",
          roofheight_h: Number(this.roomData.roofheight_h) || 0.0,
          roofheight_l: Number(this.roomData.roofheight_l) || 0.0,
          xposition: Number(this.roomData.xposition) || 0.0,
          yposition: Number(this.roomData.yposition) || 0.0,

          //면적 넣기
          feedertype: this.roomData.feedertype && this.roomData.feedertype.code || "",
          // deldate: '',
          // history: '',
          },(res) => {  
            if (res.result) {
              this.$store.commit("resMessage",res.message);
              this.msgFlag = false;

              this.resetRoomData();
              this.$emit("refreshTreeData");
            } else {
              this.loadingSave = false;
              alert(res.message);
            }
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("insertRoom API 호출 오류",err)
              alert(err);
          }
        )
      }
    },
    checkData(){
      if (!this.roomData.company.code) {
        this.$refs.companySelect.focus();
        return "상위 경영체를 선택입력하세요";
      }
      if (!this.roomData.farm.code) {
        this.$refs.farm.focus();
        return "상위 사업장을 선택입력하세요";
      }
      if (!this.roomData.building.code) {
        this.$refs.building.focus();
        return "상위 건물을 선택입력하세요";
      }
      if (!this.roomData.room_name.trim()) {
        this.$refs.room_name.focus();
        return "위치명을 입력하세요";
      }
      if (this.roomData.building_group === 'BF01'){
        if (!this.roomData.room_type?.code) {
          this.$refs.room_type.focus();
          return "돈사구분을 선택하세요";
        }
      }
    },
    resetRoomData(){
      this.roomData = {
        company : {},
        farm : {},
        building : {},

        room_code : "",
        room_name : "",
        room_type : "",
        max_pigcnt : "",
        bottom : "",
        cooltype : "",
        heattype : "",
        roofheight_h : "",
        roofheight_l : "",

        area : 0,
        building_group : "",

        xposition : "",
        yposition : "",
        feedertype : "",

        // deldate: "",
        // history: "",
      }
    },
    infoDetail(value){
      this.$store.commit("resMessage","");
      Apis.infoRoom({
        room_cd: value.room_cd, 
        },(res) => {  
          if (res.result) {
            // console.log(res.data)
            this.roomData = {
              ...this.roomData,

              company: this.companyItems.find(
                (item) => item.code === this.selectedCompany
              ) || null,
              farm : {code: res.data.farm_cd.substr(0,6), name: res.data.farm_cd.substr(6)},
              building : {code: res.data.building_cd.code, name: res.data.building_cd.name},

              room_code:res.data.room_cd,
              room_name : res.data.room_name,
              room_type : {code: res.data.room_type.substr(0,4),name: res.data.room_type.substr(4)},
              area : res.data.area || 0,
              building_group : res.data.building_cd.group,
              max_pigcnt : res.data.max_pigcnt || 0,
              bottom : {code: res.data.bottom.substr(0,4),name: res.data.bottom.substr(4)},
              cooltype : {code: res.data.cooltype.substr(0,4),name: res.data.cooltype.substr(4)},
              heattype : {code: res.data.heattype.substr(0,4),name: res.data.heattype.substr(4)},
              roofheight_h : res.data.roofheight_h != 0 && res.data.roofheight_h || "",
              roofheight_l : res.data.roofheight_l != 0 && res.data.roofheight_l || "",
              xposition : res.data.xposition != 0 && res.data.xposition || "",
              yposition : res.data.yposition != 0 && res.data.yposition || "",
              feedertype : {code: res.data.feedertype.substr(0,4),name: res.data.feedertype.substr(4)},
              // deldate : res.data.deldate,
              // history : res.data.history, 
              hintRoom : res.data.regdate + "에 등록, " + res.data.chguser + "님이 " + res.data.chgdate + "에 최종 수정",

            }
            // this.loadingRoom = false;
            this.$store.commit("resMessage",res.message);
          } else {
            alert(res.message);
            // this.loadingRoom = false;
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("API 호출 오류",err)
            this.loadingRoom = false;
            // alert(err);
        }
      ); 
    },
    comboCompanies() {
      Apis.comboCompanies({
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.companyItems = [];
            for (let i in res.data) {
            this.companyItems.push({
              code: res.data[i].company_cd,
              name: res.data[i].company_name,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboCompanies API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    updateSelectedCompany(selectedCompany) {
      this.farm = {};
      this.building = {};
      this.$emit("update:selectedCompany", selectedCompany?.code || null);
      
    },
    comboFarms() {
      Apis.comboFarms({
        company_cd: this.roomData.company && this.roomData.company.code || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            // console.log(res)
            this.farmItems = [];
            for (let i in res.data) {
            this.farmItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              code: res.data[i].farm_cd,
              name: res.data[i].farm_name,
              biz: res.data[i].farm_biz
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboFarms API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    changeFarm() {      // 하위콤보 선택시 상위 콤보 동시 세팅, 하위콤보 지우기
      if (this.roomData.farm && this.roomData.farm.company_cd) {
        this.roomData.company = {code: this.roomData.farm.company_cd, name: this.roomData.farm.company_name};
        this.roomData.building = {};
      }
    },
    comboBuildings() {
      Apis.comboBuildings({
        company_cd:this.roomData.company &&  this.roomData.company.code || "",
        farm_cd: this.roomData.farm && this.roomData.farm.code || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.buildingItems = [];
            for (let i in res.data) {
            this.buildingItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              farm_cd: res.data[i].farm_cd, 
              farm_name: res.data[i].farm_name, 
              code: res.data[i].building_cd,
              name: res.data[i].building_name,
              building_group: res.data[i].building_group,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboBuildings API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    changeBuilding() {      // 하위콤보 선택시 상위 콤보 동시 세팅
      if (this.roomData.building && this.roomData.building.company_cd) {
        this.roomData.company = {code: this.roomData.building.company_cd, name: this.roomData.building.company_name};
      }
      if (this.roomData.building && this.roomData.building.farm_cd) {
        this.roomData.farm = {code: this.roomData.building.farm_cd, name: this.roomData.building.farm_name};
        this.roomData.building_group = this.roomData.building.building_group;
      }
    },
  }

}
</script>

<style lang="scss" scoped>
@import '../info_style/info_style.scss';
.pig-content{
  border:1px solid #eeeeee;
  padding:10px;
  border-radius: 10px;
}
.space-info{
  padding:0;
}
.txt-info{
  margin-top:10px;
  font-weight:550;
}
.sub-info{
  color:#a6a6a6;
  font-size:12px;
  letter-spacing: -1px;
  margin-bottom: 10px;
}
.space{
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.space-content{
  border:1px solid #d6d6d6;
  width:200px;
  height:200px;
  display:flex;
  padding:5px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.roofspace{
  width:200px;
  height:150px;
}
.space-title{
  width:100px;
  text-align: center;
}
.space-container {
  position: relative;
  width: 300px;
  height: 200px;
  margin: 20px auto;
  margin-left:120px;
  border: 1px solid #ccc;
  background: #f7f7f7;
}

.ceiling {
  position: absolute;
  top: 0;
  width: 100%;
  height: 50%;
  background: #d0e7f9;
  clip-path: polygon(0% 100%, 100% 50%, 100% 0%, 0% 0%);
}
.sp-textfield{
  background-color: white !important;
  border:1px solid #e5e5e5 !important;
}

</style>